import { defaultMapper } from '@/common/service/default-mapper';
import {
  EVENT_SAAS_ADDITIONAL_CO_EDITOR,
  EVENT_SAAS_ADDITIONAL_HOST, EVENT_SAAS_CORE_ADDITIONAL_CO_EDITOR,
  EVENT_SAAS_CORE_ADDITIONAL_HOST,
  planTypes,
} from '@/common/constants';
import { pageConfig } from '@/common/service/page-config';
// import { getPlanTypeByCategory } from '@/common/service/parse';


export const ZOOM_SASS_ADD_ON_BASE_PLAN_MAP = {
  [EVENT_SAAS_ADDITIONAL_HOST]: planTypes.EVENT_SAAS,
  [EVENT_SAAS_ADDITIONAL_CO_EDITOR]: planTypes.EVENT_SAAS,
  [EVENT_SAAS_CORE_ADDITIONAL_HOST]: planTypes.EVENT_SAAS_CORE,
  [EVENT_SAAS_CORE_ADDITIONAL_CO_EDITOR]: planTypes.EVENT_SAAS_CORE,
};

export const AdditionalHostCategories = [
  EVENT_SAAS_ADDITIONAL_HOST, // zoom events additional host
  EVENT_SAAS_CORE_ADDITIONAL_HOST, // zoom sessions additional host
];

export const CATEGORY = AdditionalHostCategories.includes(pageConfig.editConfig.category)
  ? pageConfig.editConfig.category
  : {
      [planTypes.EVENT_SAAS]: EVENT_SAAS_ADDITIONAL_HOST,
      [planTypes.EVENT_SAAS_CORE]: EVENT_SAAS_CORE_ADDITIONAL_HOST,
    }[pageConfig.editConfig.planType];

export const Title = {
  [EVENT_SAAS_ADDITIONAL_HOST]: 'billing.events.addon.ze_hub_hosts_title',
  [EVENT_SAAS_CORE_ADDITIONAL_HOST]: 'billing.events.addon.zs_hub_hosts_title',
}[CATEGORY];

/**
 * @param {array} categories [EVENT_SAAS_ADDITIONAL_HOST, EVENT_SAAS_CORE_ADDITIONAL_HOST] | [EVENT_SAAS_ADDITIONAL_CO_EDITOR, EVENT_SAAS_CORE_ADDITIONAL_CO_EDITOR]
 * @param {string} category EVENT_SAAS_ADDITIONAL_HOST | EVENT_SAAS_CORE_ADDITIONAL_HOST | EVENT_SAAS_ADDITIONAL_CO_EDITOR | EVENT_SAAS_CORE_ADDITIONAL_CO_EDITOR
 * @param {string} planType planTypes.ADDITIONAL_HOST | planTypes.ADDITIONAL_CO_EDITOR
 * @param {string} typeNameKey
 */
export const handlePreData = (categories, category, planType, typeNameKey) => {
  return (planMapJSON) => {
    return categories.reduce((pre, key) => {
        return [
          ...defaultMapper(planMapJSON[key], planType).map((item) => {
            const baseType = ZOOM_SASS_ADD_ON_BASE_PLAN_MAP[item.category];
            return {
              ...item,
              productInfo: { max: 20, min: 1 },
              baseType,
              typeNameKey,
              isCurrentCategory: category === item.category,
              dependBasePlanTypeList: [baseType],
              billingCycleDependBasePlanTypeList: [baseType]
            };
          }),
          ...pre,
        ];
      }, []);
  };
};

export default handlePreData(AdditionalHostCategories, CATEGORY, planTypes.ADDITIONAL_HOST, 'billing.planform.title.additional_host');
